import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import ModifyReservation from '../components/Modify/ModifyReservation'
import AcceptModification from '../components/Modify/AcceptModification'
import Confirmation from '../components/Modify/Confirmation'
import StepsNavigate from '../components/Booking/components/StepsNavigate'
import AcceptPendingPayment from '../components/Modify/AcceptPendingPayment'
import constants from '../../js/lib/constants'

const ModifyRouter = () => {
  const {
    modifyCancel,
    acceptModification,
    confirmation,
    pendingPayment,
    acceptPendingPayment,
  } = constants.modify.navigateTo

  return (
    <Router
      basename={window.location.pathname}
      future={{ v7_startTransition: true }}>
      <div>
        <StepsNavigate />
        <Routes>
          <Route path={modifyCancel} element={<ModifyReservation />} />
          <Route path={acceptModification} element={<AcceptModification />} />

          <Route path={pendingPayment} element={<ModifyReservation />} />
          <Route
            path={acceptPendingPayment}
            element={<AcceptPendingPayment />}
          />

          <Route path={confirmation} element={<Confirmation />} />
        </Routes>
      </div>
    </Router>
  )
}

export default ModifyRouter
